import type { SupportCategory } from '../types';

type SupportField = 'study' | 'participants' | 'participant' | 'enrollment';
export const SUPPORT_CATEGORIES: Record<SupportCategory, { label: string; prompt: string; fields: SupportField[] }> = {
  login: { label: 'Signing in', prompt: 'What happens when you try to sign in?', fields: [] },
  'study-dashboard': { label: 'Study or page issue', prompt: 'Which page were you on, and what went wrong?', fields: ['study'] },
  'data-extraction': { label: 'Data or downloads', prompt: 'Which data were you trying to extract, and what happened?', fields: ['study', 'participants'] },
  enrollment: { label: 'Inviting participants', prompt: 'What happened when you or the participant opened the invitation?', fields: ['study', 'participant', 'enrollment'] },
  other: { label: 'Question or suggestion', prompt: 'What would you like help with or like us to improve?', fields: [] },
};

export const SUPPORT_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
export const SUPPORT_IMAGE_LIMIT = 3;
export const SUPPORT_IMAGE_MAX_BYTES = 5 * 1024 * 1024;

export function validParticipantCount(value: string): boolean {
  return value === '' || (/^\d+$/.test(value) && Number.isSafeInteger(Number(value)));
}
